<div class="description-modal-hidden"
  data-bs-toggle="modal"
  [attr.data-bs-target]="bsTarget"
  #openDescriptionModal></div>


<div class="modal fade" [id]="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div [ngClass]="getBodyClass()">

        <div class="description-modal-text-container">
          <h2 class="description-modal-text" id="modalLabel">{{ title }}</h2>
        </div>

        <ng-container *ngIf="data">
          <div [innerHTML]="data"></div>
        </ng-container >

        <ng-container *ngIf="!data || data.length == 0"
          class="no-description-container">
          <div class="no-description-text">
            {{ getNoDescriptionText() }}
          </div>
        </ng-container>

        <app-divider></app-divider>

        <div class="description-modal-button-container">
          <div class="description-modal-button">
            <app-button [text]="'FECHAR'" [fullWidth]="true" data-bs-dismiss="modal"></app-button>
          </div>
        </div>

        <div class="conclusion-modal-hidden" data-bs-dismiss="modal" #closeConclusionModal></div>

      </div>
    </div>
  </div>
</div>
